export const ROOT_PATH = "/";
export const ORDERS_PATH = "/orders";
export const RESTAURANT_ORDERS_PATH = `${ORDERS_PATH}/restaurant`;
export const CUSTOMER_ORDERS_PATH = `${ORDERS_PATH}/customer`;
